import { generateUniqueId } from '../../helpers/common';

export const SELECT_STATION = generateUniqueId();
export const SELECT_DEVICE = generateUniqueId();

export const SELECT_VIEW_PERIOD = generateUniqueId();
export const SELECT_DAY_START = generateUniqueId();
export const SELECT_MONTH_START = generateUniqueId();
export const SELECT_YEAR_START = generateUniqueId();

export const SELECT_DAY_END = generateUniqueId();
export const SELECT_MONTH_END = generateUniqueId();
export const SELECT_YEAR_END = generateUniqueId();

export const GET_SYSTEM_DEVICE_FAULT_SUMMARY = generateUniqueId();
export const SYSTEM_DEVICE_FAULT_SUMMARY_FAILURE = generateUniqueId();
export const GET_SYSTEM_DEVICE_FAULT_DETAILS = generateUniqueId();
export const SYSTEM_DEVICE_FAULT_DETAILS_FAILURE = generateUniqueId();
export const GET_SYSTEM_DEVICE_FAULT_COUNT = generateUniqueId();
export const SYSTEM_DEVICE_FAULT_DETAILS_COUNT = generateUniqueId();

export const FETCH_YEAR_INDICES_REQUEST = generateUniqueId();
export const FETCH_YEAR_INDICES_SUCCESS = generateUniqueId();
export const FETCH_YEAR_INDICES_FAILURE = generateUniqueId();

export const FETCH_STATION_DEVICE_FAULT_DEVICE_FAULT_REQUEST = generateUniqueId();
export const FETCH_STATION_DEVICE_FAULT_DEVICE_FAULT_SUCCESS = generateUniqueId();
export const FETCH_STATION_DEVICE_FAULT_DEVICE_FAULT_FAILURE = generateUniqueId();

export const FETCH_STATION_DEVICE_FAULT_DATES_REQUEST = generateUniqueId();
export const FETCH_STATION_DEVICE_FAULT_DATES_SUCCESS = generateUniqueId();
export const FETCH_STATION_DEVICE_FAULT_DATES_FAILURE = generateUniqueId();

export const FETCH_QUERY_DEVICE_FAULT_REQUEST = generateUniqueId();
export const FETCH_QUERY_DEVICE_FAULT_REQUEST_SUCCESS = generateUniqueId();
export const FETCH_QUERY_DEVICE_FAULT_REQUEST_FAILURE = generateUniqueId();